import React, {Component} from 'react';

import {Col, Image, Layout, Row} from "antd";
import './index.less'
import logo from './images/logo.png'
import {Link} from "react-router-dom";
import gongan from './images/gongan.png'
import code from './images/code.jpg'
import { setStorage} from "@/utils/localstorage";

const {Footer} = Layout;


class Index extends Component {

     handleToGov = () => {
        window.open("http://beian.miit.gov.cn");
    }


     handleSaveStorage = (value) => {
        setStorage('menuKey', value)
        this.props.setCurrentKey(value)
    }

    render() {
        return (
            <Footer className={'footer-box'} style={{ minHeight: '350px' }}>
                <Row className={'footer-box-row'} align="middle">
                    <Col className="footer-left" flex="auto">
                        <div className="logo-slogan-container">
                            <div className="logo">
                                <Image src={logo} width={'10vw'}preview={false}/>
                            </div>
                            <div className="slogan">| 忠诚 务实 勤奋 创新 |</div>
                        </div>
                    </Col>
                    <Col span={12} style={{ textAlign: 'center' }}>
                        {!this.props.homeOnly && <div className="footer-nav">
                            <Link to={'/zmBusiness/brandCreation'} onClick={()=>this.handleSaveStorage('2')} className="nav-item">至名业务</Link>
                            <span className="nav-separator">|</span>
                            <Link to={'/zmWindows'} onClick={()=>this.handleSaveStorage('4')} className="nav-item">至名之窗</Link>
                            <span className="nav-separator">|</span>
                            <Link to={'/garden'} onClick={()=>this.handleSaveStorage('5')} className="nav-item">党建园地</Link>
                            <span className="nav-separator">|</span>
                            <Link to={'/joinUs/welfare'} onClick={()=>this.handleSaveStorage('6')} className="nav-item">加入我们</Link>
                        </div>}
                        <div className="contact-info">
                            <p>地址：湖南省长沙市天心区长沙总部基地14-A、D栋</p>
                            <p>
                                <span className="phone">电话：  0731-89718783、0731-88911377</span>
                                <span className="business">&nbsp;&nbsp;&nbsp;&nbsp;商务合作：13787215593</span>
                            </p>
                            <p>邮箱：zm_team@126.com、zm@zm-team.cn</p>
                        </div>
                    </Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                        <div className="code-container">
                            <Image src={code} width={120}/>
                            <p className="scan-text">扫码关注微信公众号</p>
                        </div>
                    </Col>
                </Row>
                {/* 
                <Row className={'record-info'}>
                    <Col span={24} >
                        <div onClick={this.handleToGov} style={{cursor: "pointer"}}>
                            <Image src={gongan} preview={false}/>
                            ICP备案号：湘ICP备19013447号-1
                        </div>
                    </Col>
                </Row>
                */}
            </Footer>
        )

    }
}

export default Index
